import { render } from "./IntegrateWithText.vue?vue&type=template&id=60d5deb2&scoped=true"
import script from "./IntegrateWithText.vue?vue&type=script&lang=js"
export * from "./IntegrateWithText.vue?vue&type=script&lang=js"

import "./IntegrateWithText.vue?vue&type=style&index=0&id=60d5deb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d5deb2"]])

export default __exports__